import { mortgagePaymentByPrice } from '@search/vtbeco-frontend-core/view/filters/helpers/priceHelper';
import CheapFirst from './images/house/desktop/OMG_1.url.png';
import CheapSecond from './images/house/desktop/OMG_2.url.png';
import PoorFirst from './images/house/desktop/Poor_1.url.png';
import PoorSecond from './images/house/desktop/Poor_2.url.png';
import PoorThird from './images/house/desktop/Poor_3.url.png';
import PoorFourth from './images/house/desktop/Poor_4.url.png';
import MiddleFirst from './images/house/desktop/Middle_1.url.png';
import MiddleSecond from './images/house/desktop/Middle_2.url.png';
import MiddleThird from './images/house/desktop/Middle_3.url.png';
import MiddleFourth from './images/house/desktop/Middle_4.url.jpeg';
import MidPlusFirst from './images/house/desktop/Middle+_1.url.png';
import MidPlusSecond from './images/house/desktop/Middle+_2.url.png';
import MidPlusThird from './images/house/desktop/Middle+_3.url.png';
import MidPlusFourth from './images/house/desktop/Middle+_4.url.png';
import RichFirst from './images/house/desktop/Rich_1.url.png';
import RichSecond from './images/house/desktop/Rich_2.url.png';
import RichThird from './images/house/desktop/Rich_3.url.png';
import RichFourth from './images/house/desktop/Rich_4.url.png';
import EliteFirst from './images/house/desktop/Elite_1.url.png';
import EliteSecond from './images/house/desktop/Elite_2.url.png';
import EliteThird from './images/house/desktop/Elite_3.url.png';
import EliteFourth from './images/house/desktop/Elite_4.url.png';

import CheapFirstMobile from './images/house/mobile/ill_OMG_1.url.png';
import CheapSecondMobile from './images/house/mobile/ill_OMG_2.url.png';
import PoorFirstMobile from './images/house/mobile/ill_poor_1.url.png';
import PoorSecondMobile from './images/house/mobile/ill_poor_2.url.png';
import PoorThirdMobile from './images/house/mobile/ill_poor_3.url.png';
import PoorFourthMobile from './images/house/mobile/ill_poor_4.url.png';
import MiddleFirstMobile from './images/house/mobile/ill_middle_1.url.png';
import MiddleSecondMobile from './images/house/mobile/ill_middle_2.url.png';
import MiddleThirdMobile from './images/house/mobile/ill_middle_3.url.png';
import MiddleFourthMobile from './images/house/mobile/ill_middle_4.url.png';
import MidPlusFirstMobile from './images/house/mobile/ill_middle+_1.url.png';
import MidPlusSecondMobile from './images/house/mobile/ill_middle+_2.url.png';
import MidPlusThirdMobile from './images/house/mobile/ill_middle+_3.url.png';
import MidPlusFourthMobile from './images/house/mobile/ill_middle+_4.url.png';
import RichFirstMobile from './images/house/mobile/ill_rich_1.url.png';
import RichSecondMobile from './images/house/mobile/ill_rich_2.url.png';
import RichThirdMobile from './images/house/mobile/ill_rich_3.url.png';
import RichFourthMobile from './images/house/mobile/ill_rich_4.url.png';
import EliteFirstMobile from './images/house/mobile/ill_elite_1.url.png';
import EliteSecondMobile from './images/house/mobile/ill_elite_2.url.png';
import EliteThirdMobile from './images/house/mobile/ill_elite_3.url.png';
import EliteFourthMobile from './images/house/mobile/ill_elite_4.url.png';

export const LAND_MORTGAGE_PERCENT = 6.6;
export const LAND_MORTGAGE_STEP = 1000;
export const LAND_MIN_PAYMENT = 1000;
export const MAX_CREDIT_SUM = 200000000;
export const MIN_HOUSE_PRICE = 300000;

export const getMortgagePaymentRange = (propertyCost: number) => {
    const initialPriceRaw = mortgagePaymentByPrice(propertyCost + MIN_HOUSE_PRICE, LAND_MORTGAGE_PERCENT);

    return {
        minPayment: LAND_MIN_PAYMENT,
        maxPayment: mortgagePaymentByPrice(MAX_CREDIT_SUM, LAND_MORTGAGE_PERCENT),
        initalPrice: Math.ceil(initialPriceRaw / LAND_MORTGAGE_STEP) * LAND_MORTGAGE_STEP
    };
};

const desktopImages = {
    1: [ CheapFirst, CheapSecond ],
    2: [ PoorFirst, PoorSecond, PoorThird, PoorFourth ],
    3: [ MiddleFirst, MiddleSecond, MiddleThird, MiddleFourth ],
    4: [ MidPlusFirst, MidPlusSecond, MidPlusThird, MidPlusFourth ],
    5: [ RichFirst, RichSecond, RichThird, RichFourth ],
    6: [ EliteFirst, EliteSecond, EliteThird, EliteFourth ]
};

const mobileImages = {
    1: [ CheapFirstMobile, CheapSecondMobile ],
    2: [ PoorFirstMobile, PoorSecondMobile, PoorThirdMobile, PoorFourthMobile ],
    3: [ MiddleFirstMobile, MiddleSecondMobile, MiddleThirdMobile, MiddleFourthMobile ],
    4: [ MidPlusFirstMobile, MidPlusSecondMobile, MidPlusThirdMobile, MidPlusFourthMobile ],
    5: [ RichFirstMobile, RichSecondMobile, RichThirdMobile, RichFourthMobile ],
    6: [ EliteFirstMobile, EliteSecondMobile, EliteThirdMobile, EliteFourthMobile ]
};

const getImageUrl = (range: number, isMobile: boolean) => {
    const images: { [key: number]: string[] } = isMobile ? mobileImages : desktopImages;

    return images[range][Math.floor(Math.random() * images[range].length)];
};

export const getRandomImageFromPrice = (amount: number, isMobile: boolean = false) => {
    if (amount <= 10000) return getImageUrl(1, isMobile);
    else if (amount <= 28000) return getImageUrl(2, isMobile);
    else if (amount <= 70000) return getImageUrl(3, isMobile);
    else if (amount <= 120000) return getImageUrl(4, isMobile);
    else if (amount <= 180000) return getImageUrl(5, isMobile);
    return getImageUrl(6, isMobile);
};

export enum LandMortgageActionType {
    IzhsCalc = 'izhs_calc',
    IzhsLearnMore = 'izhs_learn_more',
    IzhsCalcReq = 'izhs_calc_req',
    IzhsReq = 'izhs_req'
}
